module.exports = __webpack_public_path__ + "nprofile_icon.svg";